import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocTeamAlertIssueSyncingRoute: InvariantJiraRoute = {
	name: 'eoc-team-alert-issue-syncing',
	path: '/jira/ops/teams/:teamId/syncs',
	exact: true,
};
